export default __webpack_public_path__ + "video-rect87b3ba.svg";